var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.752696 22.603L22.6026 0.752392C23.6044 -0.250797 25.2439 -0.250797 26.2458 0.752392C27.2476 1.75558 27.2489 3.39382 26.2458 4.39701L4.39588 26.2476C3.39272 27.2508 1.75454 27.2508 0.751381 26.2476C-0.25046 25.2444 -0.25046 23.6062 0.751381 22.603H0.752696Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2471 22.603L4.39725 0.752392C3.39541 -0.250797 1.75591 -0.250797 0.754072 0.752392C-0.24777 1.75558 -0.249085 3.39382 0.754072 4.39701L22.6039 26.2476C23.6071 27.2508 25.2453 27.2508 26.2484 26.2476C27.2503 25.2444 27.2503 23.6062 26.2484 22.603H26.2471Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerClose);
export default __webpack_public_path__ + "static/media/Hamburger_close.9227c566fa9f4c470eacbee36904e471.svg";
export { ForwardRef as ReactComponent };